import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';
import withImage from '../../../../shared/components/utils/hoc/withImage';

const ChannelListChannelLogo = styled.img<React.CSSProperties>`
  margin-right: ${36 * Screen.widthRatio}px;
  max-height: ${80 * Screen.widthRatio}px;
  width: ${80 * Screen.widthRatio}px;
`;

export default withImage(ChannelListChannelLogo, false);
